<div class="container-fluid page" *ngIf="!editNews">
    <div class="d-flex page__box p-3 mt-2"><img src="./assets/arrow_logo.png" class="arrow"
            (click)="listPage()">&nbsp;&nbsp;
        <p style="padding-top: 0px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-eye"
                viewBox="0 0 16 16">
                <path
                    d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
            </svg>
        </p>
        <p style="font-size: 20px;padding-top: 11px;">
            {{userlist.view}}
        </p>
        &nbsp;&nbsp;
        <p style="padding-top: 0px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                class="bi bi-hand-thumbs-up" viewBox="0 0 16 16">
                <path
                    d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2.144 2.144 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a9.84 9.84 0 0 0-.443.05 9.365 9.365 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111L8.864.046zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a8.908 8.908 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.224 2.224 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.866.866 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
            </svg>
        </p>
        <p style="font-size: 20px;padding-top: 13px;">
            {{userlist.like}}
        </p>
        &nbsp;&nbsp;&nbsp;
        <p style="padding-top: 4px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor"
                class="bi bi-chat-square-text" viewBox="0 0 16 16">
                <path
                    d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                <path
                    d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" />
            </svg>
        </p>&nbsp;
        <p style="font-size: 20px;padding-top: 10px;">{{userlist.totalAnswer}}</p> &nbsp;&nbsp;&nbsp;&nbsp;

        <p style="font-size: 20px;padding-top: 10px;">
            {{userlist.postedBy}} ({{userlist.role}}) &nbsp;&nbsp;&nbsp;&nbsp;
            {{userlist.postedDate | date:'dd
            MMM, yyyy'}}</p>
    </div>

    <div class="page__content shadow p-3 ">
        <div class="">
            <br />
            <div class="row" style="margin-top: -40px;">

            </div>
            <mat-card>
                <div class="example-header">
                    <div class="row">
                        <div class="col-md-10" style="padding: inherit;" >
                            <!-- {{userlist.postFile}} -->
                            
                            
                                <div  *ngIf="isImage">
                                    <img [src]="imagePath" style="width: 10%;">
                                </div>
                               
                                <div class="video" *ngIf="isVideo">
                                    <video controls (click)="toggleVideo()" #videoPlayer width="220" height="140">
                                        <!-- <source src="{{videopath}}"   [src]="videopath"type="video/mp4" /> -->
                                        <source   [src]="videopath"type="video/mp4" />
                                        <source   [src]="videopath"type="video/webm" />
                                        Browser not supported
                                    </video>
                                </div>
                                <h6 style="padding: inherit;">
                                <!-- {{userlist.description}} -->
                                <!-- <div>  <img [src]="imagePath" style="width: 15%;"></div> -->
                              
                                {{userlist.question}} &nbsp;
                                   <!-- edit post -->
                                   <mat-icon (click)="edit(userlist)" *ngIf="userlist.postedBy==userName" class="cursor">edit</mat-icon>&nbsp;&nbsp;
                                   <mat-icon (click)="deletePost(newData)" *ngIf="userlist.postedBy==userName" class="cursor">delete</mat-icon>
                                  &nbsp;
                                    <img src="/assets/flag.png" width="28px" height="40px" style="padding-bottom: 15px;" *ngIf="userlist.isFlag">
                                  
                                 
                                   <!-- edit post end -->
                            </h6>
                            
                            <!-- {{userlist.question}} -->
                        </div>
                        <div class="col-md-2">
                            &nbsp;
                            <button class="buttonT" type="submit" (click)="openCloseQuestionpopup()" *ngIf="!userlist.isClose">Close</button>
                            <button class="button" type="submit" (click)="openPutBackpopup()" *ngIf="userlist.isClose">Put Back</button>
                        </div>
                        <!-- <div class="col-md-2">
                            <button class="button" type="submit" (click)="openPutBackpopup()" *ngIf="userlist.isClose">Put Back</button>
                        </div> -->
                        <div class="row">
                            <div class="col-md-12" style="padding: initial;" >
                        <h6 style="padding: inherit;">
                            <!-- {{userlist.question}} -->
                            {{userlist.description}}
                        </h6>
                        </div>
                        </div>
                    </div>
                    <hr>

                </div>
                <!-- add new code -->
                <div style="padding: 70px;" *ngIf="imageOrVideopath"></div>
                <div style="padding: 65px;" *ngIf="!imageOrVideopath" ></div>
<div>
                <h4> {{userlist.totalAnswer}} Answers</h4>

                <h6 *ngFor="let item of userlist1;">

                    {{item.answer}}

                    <br>

                    <!-- <br> -->
                    <b>
                        <br>

                        <div class="row">
                            <div class="col-md-2" style="    padding-top: 27px;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                                    class="bi bi-hand-thumbs-up" viewBox="0 0 16 16">
                                    <path
                                        d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2.144 2.144 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a9.84 9.84 0 0 0-.443.05 9.365 9.365 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111L8.864.046zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a8.908 8.908 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.224 2.224 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.866.866 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
                                </svg>{{item.answerLikes}}
                                <!-- <img src="/assets/flag.png" width="20px" height="20px" *ngIf="item.isFlag"> -->
                                <!-- edit post -->
                                <mat-icon (click)="editAnswer(item.answerId)" *ngIf="item.answeredBy==userName" class="cursor">edit</mat-icon>&nbsp;&nbsp;
                                <mat-icon (click)="deleteAnswer(item.answerId)" *ngIf="item.answeredBy==userName" class="cursor">delete</mat-icon>&nbsp;
                                <img src="/assets/flag.png" width="28px" height="40px" style="padding-bottom: 15px;" *ngIf="item.isFlag">
                              
                                <!-- edit post end -->
                            </div>
                            <div class="col-md-8" style="padding-top: 38px;">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <!-- &nbsp; &nbsp;&nbsp; -->
                                Answer by {{item.answeredBy}}
                                ({{item.answeredByRole}}) &nbsp;&nbsp;on {{item.answeredDate | date:'dd
                                MMM, h:mm a'}}
                              
                            </div>
                            <div class="col-md-2">
                                &nbsp;
                                <button class="buttonT" type="submit"  (click)="openCloseQuestionpopup1(item.answerId)" *ngIf="!item.isClose">Close</button>
                                <button class="button" type="submit" (click)="openPutBackpopup1(item.answerId)" *ngIf="item.isClose">Put Back</button>
                            </div>
                            <!-- <div class="col-md-2">
                                <button class="button" type="submit" (click)="openPutBackpopup()" *ngIf="userlist1.isClose">Put Back</button>
                            </div> -->

                        </div>
                        <hr>

                    </b>
                </h6>
            </div>


                <h4>Your Answer</h4>
                <mat-card-content class="pa-1" *ngIf="!editanswer">
                    <form [formGroup]="postnewanswer" (ngSubmit)="onPostnewanswer(userlist.PostId)">
                        <div class="fulllwidth">
                            <textarea id="w3review" formControlName="Answer" name="w3review" rows="4"
                                cols="155"></textarea>
                            <div class="row">
                                <div class="col-md-8">
                                </div>
                                <div class="col-md-4">

                                    <button mat-button type="submit" class="submitBtn pull-right">Post Your
                                        Answer</button>
                                </div>
                            </div>

                        </div>
                    </form>
                </mat-card-content>

                <!-- edit answer -->
                <mat-card-content class="pa-1" *ngIf="editanswer">
                    <form [formGroup]="postnewanswer" (ngSubmit)="onUpdateAnswer()">
                        <div class="fulllwidth">
                            <textarea id="w3review" formControlName="Answer" name="w3review" rows="4"
                                cols="155"></textarea>
                            <div class="row">
                                <div class="col-md-8">
                                </div>
                                <div class="col-md-4">

                                    <button mat-button type="submit" class="submitBtn pull-right">Update Your
                                        Answer</button>
                                </div>
                            </div>
                         

                        </div>
                    </form>
                </mat-card-content>
                <!-- edit answer end -->

            </mat-card>
            

        </div>

    </div>

</div>
<!---==============================edit post data html =================================================-->
<div class="container-fluid page" *ngIf="editNews">
    <div class="d-flex page__box p-3 mt-2"><img src="./assets/arrow_logo.png" class="arrow"
            (click)="listPage1()">&nbsp;&nbsp;Edit Post Question</div>
    <div class="example-header1">
        <mat-card class="matCardForm matcard">
            <mat-card-content class="pa-1 matcard" style="width: auto !important;">
                <!-- <form [formGroup]="askquestionform" (ngSubmit)="onSubmit1()"> -->
                <form [formGroup]="askquestionform">
                    <!-- <div class="fulllwidth"> -->

                        <mat-form-field>
                            <input style="width: 938px;" type="text" formControlName="questionTitle" 
                             required matInput placeholder="Enter title here"><br>
                        </mat-form-field>
                        <div *ngIf="askquestionform.controls['questionTitle'].invalid && (askquestionform.controls['questionTitle'].dirty || askquestionform.controls['questionTitle'].touched)">
                            <div *ngIf="questionTitle.errors.minlength" style="width: fit-content; color: red;">
                                Enter Title must be at least 20 characters long.
                           </div>
                           <div *ngIf="questionTitle.errors.maxlength" style="width: fit-content;color: red;">
                            Enter Title  maximum 60 characters long.
                       </div>
                    </div>
                        <br>

                        <p style="text-align: left;padding-left: 4px;"><b>Post the question or topic with all the
                                necessary details.</b>&nbsp;&nbsp;
                                <!-- <b class="guidelineClass"
                                (click)="guidelinePage()">Read our community guidelines.</b> -->
                            </p>
                        <textarea id="w3review" formControlName="Answer"
                            placeholder="Enter your question here, max 400 characters." style="width: 100%"
                            formControlName="quetionDiscription" name="w3review" rows="10" cols="120" ></textarea>
                            <div *ngIf="askquestionform.controls['quetionDiscription'].invalid && (askquestionform.controls['quetionDiscription'].dirty || askquestionform.controls['quetionDiscription'].touched)">
                                <div *ngIf="quetionDiscription.errors.maxlength" style="width: fit-content; color: red;">
                                    Enter quetion discription must be maximum 400 characters long.
                               </div>
                               </div>

                        <div class="row">
                            <div class="col-12" style="margin-bottom: 10px;">
                                <div class="col-12">
                                    <p class="pull-left" style="    width: 100%;
                                text-align: start;">Attach a reference document: An image file less than 5 MB (PNG,
                                        JPEG/JPG)</p>
                                </div>
                                <div class="col-12">
                                    <input class="col-6 pull-left" formControlName="Image"
                                        (change)="processImage1($event)" type="file" accept="video/mp4,video/x-m4v,video,image/png, image/gif, image/jpeg/*"#inputFile />
                                        <!-- accept="image/png, image/gif, image/jpeg"  -->
                                    <button class="col-1 pull-left" (click)="removeFile()" *ngIf="isButtonVisible"
                                        matTooltip="remove attachment" style="border: none;" mat-stroked-button
                                        aria-label="remove file">
                                        <mat-icon [ngStyle]="{'color':'red'}">clear</mat-icon>
                                    </button>
                                    <!-- <img [src]="imagePath" style="width: 15%;">
                                    <div class="video">
                                        <video controls (click)="toggleVideo()" #videoPlayer width="220" height="140">
                                            <source src="{{videopath}}"   [src]="videopath"type="video/mp4" />
                                            Browser not supported
                                        </video>
                                    </div> -->
                                    <!-- <div  *ngIf="imageOrVideopath"> -->
                                        <div  *ngIf="isImage">
                                        <img [src]="imagePath" style="width: 8%;">
                                    </div>
                                   
                                    <!-- <div class="video" *ngIf="!imageOrVideopath"> -->
                                        <div  *ngIf="isVideo">
                                        <video controls (click)="toggleVideo()" #videoPlayer width="220" height="140">
                                            <!-- <source src="{{videopath}}"   [src]="videopath"type="video/mp4" /> -->
                                            <source   [src]="videopath"type="video/mp4" />
                                            <source   [src]="videopath"type="video/webm" />
                                            Browser not supported
                                        </video>
                                    </div>
                                  
                                </div>
                            
                            </div>
                         
                           
                                <div class="col-md-8">
                                    <!-- <span *ngIf="attachfile != null">
                                        <a target="_blank" href="{{attachfile}}">
                                          Previous Upload File </a>
                                      </span> -->
                                    
                                </div>
                                <div class="col-md-4">
                                    <button style='margin-right:16px'class="pull-right submitBtn" mat-button
                                    (click)="listPage1()"[disable]="disable">Cancel</button>

                                     <button style='margin-right:16px' class="pull-right submitBtn" mat-button type="submit"
                                        (click)="onSubmit1()" [disable]="disable">Update</button>
                                        
                                </div>

                        </div>

                    <!-- </div> -->

                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>
